import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './app/store';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BreadcrumbProvider } from "./Components/Breadcrumbs/BreadcrumbContext";
import { BrowserRouter } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  {/* <React.StrictMode> */}
  <BreadcrumbProvider>
  <BrowserRouter>
    <App />
    </BrowserRouter>
    </BreadcrumbProvider>
  {/* </React.StrictMode> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
